/**
 * 工具类  Update by Neil 2020-8-25 （通用工具类）
 */
var SIGN_REGEXP = /([yMdhsm])(\1*)/g
var DEFAULT_PATTERN = 'yyyy-MM-dd'

function padding(s, len) {
  let l = len - (s + '').length
  for (var i = 0; i < l; i++) {
    s = '0' + s
  }
  return s
};

export default {
  mapToArrays(map){
    if (!map) {
      return [];
    }

    let arr = [];
    let values = map.entries();
  },
  pathProps(data, parent, prop) {
    if (data[parent]) {
      return  this.pathProps(data[parent], parent, prop)  + ',' + data[prop];
    } else {
      return data[prop];
    }
  },
  /**
   * 获取 blob
   * @param  {String} url 目标文件地址
   * @return {cb}
   */
  getBlob(url,cb) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    xhr.onload = function() {
    if (xhr.status === 200) {
      cb(xhr.response);
    }
    };
    xhr.send();
  },
  /**
  * 保存
  * @param  {Blob} blob
  * @param  {String} filename 想要保存的文件名称
  */
  saveAs(blob, filename) {
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      var link = document.createElement('a');
      var body = document.querySelector('body');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      // fix Firefox
      link.style.display = 'none';
      body.appendChild(link);
      link.click();
      body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    };
  },
  /**
  * 下载
  * @param  {String} url 目标文件地址
  * @param  {String} filename 想要保存的文件名称
  */
  download(url, filename) {
    this.getBlob(url, (blob) => {
      this.saveAs(blob, filename);
    });
  },
  isEmpty: function (obj) {
    if(typeof obj == "undefined" || obj == null || obj == ""){
      return true;
    }else{
      return false;
    }
  },
  isNotEmpty: function (obj) {
    return !this.isEmpty(obj);
  },
  downloadBlobFile: function (res, fileName) {
    if (res  instanceof Blob){
      const blob = res;
      const a = document.createElement("a")
      a.href = URL.createObjectURL(blob)
      a.download = fileName // 这里填保存成的文件名
      a.click()
      URL.revokeObjectURL(a.href)
    } else {
      console.log("error")
    }
  },
  getQueryStringByName: function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    var r = window.location.search.substr(1).match(reg)
    var context = ''
    if (r != null) {
      context = r[2]
    }
    reg = null
    r = null
    return context === null || context === '' || context === 'undefined' ? '' : context
  },
  formatDate: {

    format: function (date, pattern) {
      pattern = pattern || DEFAULT_PATTERN
      return pattern.replace(SIGN_REGEXP, function ($0) {
        switch ($0.charAt(0)) {
          case 'y':
            return padding(date.getFullYear(), $0.length)
          case 'M':
            return padding(date.getMonth() + 1, $0.length)
          case 'd':
            return padding(date.getDate(), $0.length)
          case 'w':
            return date.getDay() + 1
          case 'h':
            return padding(date.getHours(), $0.length)
          case 'm':
            return padding(date.getMinutes(), $0.length)
          case 's':
            return padding(date.getSeconds(), $0.length)
        }
      })
    },
    parse: function (dateString, pattern) {
      var matchs1 = pattern.match(SIGN_REGEXP)
      var matchs2 = dateString.match(/(\d)+/g)
      if (matchs1.length === matchs2.length) {
        var _date = new Date(1970, 0, 1)
        for (var i = 0; i < matchs1.length; i++) {
          var _int = parseInt(matchs2[i])
          var sign = matchs1[i]
          switch (sign.charAt(0)) {
            case 'y':
              _date.setFullYear(_int);
              break
            case 'M':
              _date.setMonth(_int - 1);
              break
            case 'd':
              _date.setDate(_int);
              break
            case 'h':
              _date.setHours(_int);
              break
            case 'm':
              _date.setMinutes(_int);
              break
            case 's':
              _date.setSeconds(_int);
              break
          }
        }
        return _date
      }
      return null
    }
  }

}



// WEBPACK FOOTER //
// ./src/common/util.js